import React, { Component } from "react";
import "../../Styles/Team.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Axios from "axios";
import { team_wallmag } from "../common/AppConstants";
import { Image } from "react-bootstrap";

export default class Team extends Component {
  state = {
    data: null
  };

  componentDidMount() {
    Axios.get(team_wallmag).then(res => {
      this.setState({
        data: res.data
      });
      //console.log(res);
    });
  }

  render() {
    return (
      <div style={{ background: "white" }}>
        <Header
          heading="People Behind WallMag"
          sub_heading="We do what we love and love what we do"
        />

        <div className="container mt-4">
          <div className="row">
            {this.state.data !== null
              ? this.state.data.items.map(value => {
                  return (
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-4">
                      <div className="row">
                        <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 mt-4">
                          <Image
                            className="pro-pic"
                            roundedCircle
                            src={value.profilePicture}
                          />
                        </div>

                        <div
                          className="col-8 col-sm-8 col-md-9 col-lg-9 col-xl-9 mt-4"
                          style={{ marginLeft: "-15px" }}
                        >
                          <p className="emp_name">{value.fullName}</p>
                          <p className="about_emp">{value.designation}</p>
                          <p className="emp-desc">{value.details}</p>
                        </div>
                      </div>
                    </div>
                  );
                })
              : ""}
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
